export const get = (key: string) => {
    try {
        const isSupport = 'localStorage' in window && window.localStorage !== null;
        if (!isSupport) {
            return null;
        }
        const str = window.localStorage[key];
        if (!str) {
            return null;
        }
        const data = JSON.parse(str);
        return data;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const set = (key: string, value: {[index: string]: any} | number | boolean | string | any[]) => {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error(e);
    }
};

export const remove = (key: string) => {
    window.localStorage.removeItem(key);
};

export const getKeyWith = (key: string) => {
    try {
        const isSupport = 'localStorage' in window && window.localStorage !== null;
        if (!isSupport) {
            return null;
        }
        const data = window.localStorage;
        return Object.keys(data).filter(name => {
            return name.startsWith(key);
        });
    } catch (e) {
        console.error(e);
        return [];
    }
};

export const sessionStorageGet = (key: string) => {
    try {
        const isSupport = 'sessionStorage' in window && window.sessionStorage !== null;
        if (!isSupport) {
            return null;
        }
        const str = window.sessionStorage[key];
        if (!str) {
            return null;
        }
        const data = JSON.parse(str);
        return data;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const sessionStorageSet = (key: string, value: {[index: string]: any} | number | boolean | string | any[]) => {
    try {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.error(e);
    }
};

export const sessionStorageRemove = (key: string) => {
    window.sessionStorage.removeItem(key);
};
